// extracted by mini-css-extract-plugin
export var headerMargin = "faq-module--header-margin--c2ca6";
export var navActive = "faq-module--nav-active--108b4";
export var navLinks = "faq-module--nav-links--46980";
export var stickyNav = "faq-module--sticky-nav--4407d";
export var stickyNavFixed = "faq-module--sticky-nav__fixed--89fe8";